import React from 'react'

const GRADIENT = 'linear-gradient(90deg, rgba(231, 33, 68, 1), rgba(118, 84, 158, 1))'

// דיאלוג הרשאת ההתראות — UI בלבד, בלי לוגיקה. מוצג רק ממסך ה-Login אחרי התחברות מוצלחת.
// mode='ask'     : ההרשאה עדיין לא נשאלה — "אפשר התראות" (onAllow) / "לא עכשיו" (onDismiss)
// mode='blocked' : ההרשאה חסומה בדפדפן/במכשיר — הסבר + "הבנתי" (onDismiss)
// הכפתורים type="button" כי הדיאלוג יושב מעל ה-<form> של ה-Login.
const PushPermissionDialog = ({ mode, onAllow, onDismiss }) => {
  const blocked = mode === 'blocked'
  return (
    <div className='h-full w-full fixed top-0 left-0 z-50 bg-[rgba(49,49,49,0.8)] flex justify-center items-center flex-col'>
      <div className='bg-white w-[80%] max-w-md rounded-xl'>
        <div className='rounded-xl w-full border border-b-transparent p-4 flex flex-col items-center bg-red-50' style={{ direction: 'rtl' }}>
          <p className='w-full font-Hebbo font-medium text-black text-center whitespace-pre-line mb-4'>
            {blocked
              ? 'ההתראות חסומות בדפדפן/במכשיר.\nכדי לקבל התראות ועדכונים מהאפליקציה יש לאפשר אותן דרך הגדרות הדפדפן או המכשיר.'
              : 'רוצים לקבל התראות ועדכונים מהאפליקציה?\nבמסך הבא הדפדפן יבקש את אישורכם לקבלת התראות.'}
          </p>
          {blocked ? (
            <button type='button' className='p-3 rounded-lg text-white font-bold' style={{ background: GRADIENT }} onClick={onDismiss}>
              הבנתי
            </button>
          ) : (
            <div className='flex gap-3'>
              <button type='button' className='p-3 rounded-lg text-white font-bold' style={{ background: GRADIENT }} onClick={onAllow}>
                אפשר התראות
              </button>
              <button type='button' className='p-3 rounded-lg border border-[#394351] text-[#394351] font-bold' onClick={onDismiss}>
                לא עכשיו
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PushPermissionDialog
